import type { PromoTemplateCollectionsFragment } from 'bundles/front-page/__generated__/contentfulTypes';

const normalizeSpotlightCollectionsModuleContent = (content: PromoTemplateCollectionsFragment) => {
  if (!content.collectionSetsCollection?.items?.length) return null;

  const collectionSets = content.collectionSetsCollection.items
    .map((item) => {
      if (!item || !item.collectionModuleId) return null;
      return {
        id: [item.collectionModuleId, item.presetCollectionId].filter(Boolean).join('-'),
        collectionModuleId: item.collectionModuleId,
        presetCollectionId: item.presetCollectionId as string,
        filterName: item.filterName,
      };
    })
    .filter(Boolean);

  return {
    headline: content.headline ?? '',
    description: content.description ?? '',
    ctaText: content.ctaText ?? '',
    ctaTarget: content.ctaTarget ?? '',
    collectionSets,
    backgroundColor: content.backgroundColor ?? '',
    gradientBackgroundColor: content.gradientBackgroundColor ?? '',
  };
};

export default normalizeSpotlightCollectionsModuleContent;
